export const environment = {
  production: false,
  baseUrl: 'https://api.xn--2i0b75tjsfuxf9uw.xn--3e0b707e',
  kakaoAppKey: '0f3ccd8bc563577cfa231be1833080e5',
  kakaoJavascriptKey: '6475029829d9593f0a03af5e00705778',
};
